import contributorConstants from "../constants/contributorConstants";

export const retrieveContributors = (payload: any) => ({
  type: contributorConstants.GET_CONTRIBUTORS_LIST,
  payload,
});

export const addContributor = (payload: any) => ({
  type: contributorConstants.ADD_CONTRIBUTOR_REQ,
  payload,
});

export const editContributor = (payload: any) => ({
  type: contributorConstants.EDIT_CONTRIBUTOR_REQUEST,
  payload,
});

export const deleteContributor = (payload: any) => ({
  type: contributorConstants.DELETE_CONTRIBUTOR_REQUEST,
  payload,
});

export const resetContributors = () => ({
  type: contributorConstants.RESET_CONTRIBUTORS,
});
